export const MAX_USER_IMPORT_COUNT = 100;

export type UserImportPreviewRow =
{
    firstname: string;
    lastname: string;
    email: string;
};

export type UserImportPreviewResult =
    | { status: 'ok'; users: UserImportPreviewRow[]; }
    | { status: 'error'; clientMessage: string; };
